import React, {useState, useEffect} from "react";
import Helmet from "react-helmet";
import cogoToast from "cogo-toast";
import XLSX from "xlsx"; // para leer el xls

import {Consumer} from "../../context";
import Sidebar from "../../components/Sidebar";
import ConfigSideBar from "../../components/ConfigSideBar";
import Header from "../../components/Header";
import TableAttributes from "../../components/Tables/TableAttributes";
import ControlUpload from "../../components/Controls/ControlUpload";
import Paginator from "../../components/Paginator";
import Modal from "../../components/modal/DinamicModal";
import UploadXLS from "../../components/modal/UploadXLS";
import exportToExcel from "../../tool/excel";

import request from "../../tool/request";
import {URL_API} from "../../contants/url_api";

const Request = new request();

const Inventory = (props) => {
	const [user, setUser] = useState(props.context.user);
	const [dataset, setDataset] = useState([]);
	const [inputValue, setInputValue] = useState("");
	const [loading, setLoading] = useState(false);
	const [exporting, setExporting] = useState(false);
	const [page, setPage] = useState(1);
	const [fileName, setFileName] = useState("");
	const [listAttrib, setListAttrib] = useState([]);

	useEffect(() => {
		if (user !== props.context.user) {
			setUser(props.context.user);
		}
	}, [props.context.user]);

	function inputChange(event) {
		setInputValue(event.target.value);
	}

	async function selectPage(page) {
		setPage(page);
	}

	async function searchHandler() {
		if (inputValue != "") {
			setDataset([]);
			setLoading(true);
			const data = {
				user_id: user.user_id,
				parameter: inputValue,
			};
			const response = await Request.get(URL_API + "/publication/get/attributos", data);

			if (!response.empty && !response.error) {
				setDataset(response.data);
			} else {
				setDataset([]);
			}
			setLoading(false);
		}
	}

	async function keypress(event) {
		if (event.keyCode === 13) {
			searchHandler();
		}
	}

	async function uploadHandler() {
		let modal = document.getElementById("uploadModal");

		setFileName("");
		setListAttrib([]);
		if (modal) {
			modal.classList.remove("hide-dinamic-modal");
			modal.classList.add("show-modal");
		}
	}

	async function saveAttributos(event) {
		event.preventDefault();
		const data = {
			data: listAttrib,
			user_id: user.user_id,
			access_token: user.access_token,
			refresh_token: user.refresh_token,
			expire: user.expire,
		};
		const response = await Request.post(URL_API + "/publication/save/atributos", data);

		if (response.error) {
			cogoToast.error("Hubo un error al guardar el listado.", {
				position: "bottom-right",
			});
		} else {
			cogoToast.loading("Ha iniciado la actualización de atributos.", {
				position: "bottom-right",
			});
			let modal = document.getElementById("uploadModal");
			if (modal) {
				modal.classList.add("hide-dinamic-modal");
				modal.classList.remove("show-modal");
			}
		}
	}

	async function uploadFile(event) {
		if (event.target.files[0]) {
			const reader = new FileReader();
			const rABS = !!reader.readAsBinaryString;
			let nombre = event.target.files[0].name;

			if (rABS) {
				reader.readAsBinaryString(event.target.files[0]);
			} else {
				reader.readAsArrayBuffer(event.target.files[0]);
			}

			reader.onload = (e) => {
				const bstr = e.target.result;
				// console.log(bstr);
				const wb = XLSX.read(bstr, {
					type: rABS ? "binary" : "array",
					bookVBA: true,
				});
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				let data = XLSX.utils.sheet_to_json(ws);

				let dataset = data.map((row) => {
					return row;
				});

				setListAttrib(dataset);
				setFileName(nombre);
			};
			event.target.value = null;
		}
	}

	async function toExportHandler(event) {
		if (dataset.length > 0) {
			try {
				setExporting(true);
				setExporting(true);

				const buffer = await exportToExcel(dataset, ["title"]);

				const bytes = new Uint8Array(buffer);
				const blob = new Blob([bytes]);
				const link = document.createElement("a");
				link.href = window.URL.createObjectURL(blob);
				const fileName = "Listado.xlsx";
				link.download = fileName;
				link.click();

				setExporting(false);
			} catch (error) {
				console.log(error);
				setExporting(false);
			}
		}
	}

	return (
		<div className="Home column">
			<Helmet>
				<title>Atributos | Plataforma de sincronización</title>
			</Helmet>
			<Header />
			<div className="row">
				<div className="column sidebar" id="sidebar">
					<Sidebar />
				</div>

				<div className="column align-center ">
					<div className="row">
						<div className="white-space-24"></div>
					</div>
					<ControlUpload
						title="Atributos"
						valueInput={inputValue}
						inputChange={inputChange.bind(this)}
						searchHandler={searchHandler.bind(this)}
						keypress={keypress.bind(this)}
						uploadHandler={uploadHandler.bind(this)}
						toExportHandler={toExportHandler.bind(this)}
						exporting={exporting}
					/>
					<div className="row">
						<div className="white-space-32"></div>
					</div>
					<div className="row justify-center align-center">
						<TableAttributes dataset={dataset} isLoading={loading} page={page} />
					</div>
					<div className="row">
						<div className="white-space-16"></div>
					</div>
					<div className="row">
						<Paginator pages={Math.ceil(dataset.length / 20)} setPage={selectPage.bind(this)} />
					</div>
				</div>
			</div>
			<Modal
				idModal={"uploadModal"}
				sizeModalContainer={"mini"}
				title={"Buscar Archivo"}
				btnTextSuccess={"Guardar"}
				success={saveAttributos.bind(this)}
				showBtnSuccess={true}
				btnTextCancel={"Cancelar"}
				showBtnCancel={true}
				loadingSave={false}
			>
				<UploadXLS fileName={fileName} uploadFile={uploadFile.bind(this)} />
			</Modal>

			<ConfigSideBar />
		</div>
	);
};

export default Consumer(Inventory);
